module.exports = __webpack_public_path__ + "img/analytics-cmbs-report-stream.f1cf1e1a.png";